<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-link class="navbar-brand" to="/">
        <img class="navbar-brand-full" src="img/brand/logo-symbol.png" width="30" height="30" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="img/brand/logo-symbol.png" width="30" height="30" alt="CoreUI Logo">
      </b-link>
      <!--<Breadcrumb :list="list" class="p-0 m-0 ml-2" />-->
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none" :to="'/team/'+contactId" v-if="isLoggedIn && contactId && !isTokenAuth">
          <i class="far fa-user mr-2"></i> {{ contactName }}
        </b-nav-item>
        <!-- <b-nav-item class="d-md-down-none" to="/settings" v-if="isLoggedIn">
          <i class="far fa-cog"></i>
        </b-nav-item> -->
        <b-nav-text class="mx-3 text-muted" v-if="isLoggedIn && !isTokenAuth">
          |
        </b-nav-text>
        <b-nav-item class="d-md-down-none" to="/submissions/add" v-if="isLoggedIn && !isTokenAuth">
          <i class="far fa-plus"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none" to="/cart" v-if="isLoggedIn && !isTokenAuth">
          <i class="far fa-shopping-basket"></i>
          <b-badge v-if="cartCount" pill variant="danger">{{cartCount}}</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none" @click="logout" v-if="isLoggedIn">
          <i class="far fa-sign-out"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none" to="/login" v-if="!isLoggedIn">
          <i class="far fa-sign-in"></i>
        </b-nav-item>
      </b-navbar-nav>
      <!--<AsideToggler class="d-none d-lg-block" v-if="isLoggedIn" />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter class="d-print-none">
      <!--footer-->
      <div>
        <a to="/">Customer Portal</a>
        <span class="ml-1">&copy; 2024 <a href="http://downtoearthlabs.com/" target="_blank">Down To Earth Labs.</a></span>
      </div>
      <div class="ml-auto"></div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import nav_guest from '@/_nav_guest'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import {AUTH_LOGOUT} from '@/store/action-types'
import LoadingOverlay from "../components/shared/LoadingOverlay";
import markerSDK from '@marker.io/browser'

export default {
  name: 'DefaultContainer',
  components: {
    LoadingOverlay,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    markerSDK
  },
  data () {
    const isAuthenticated = this.$store.getters.isAuthenticated;
    const authType = this.$store.getters.getAuthType;
    let currentNav = nav_guest.items;

    if (isAuthenticated) {
      if (authType === 'token') {
        currentNav = nav.items.filter(item => item.availableOnTokenAuth);
      } else {
        currentNav = nav.items;
      }
    }

    return {
      loggedIn: this.$store.getters.isAuthenticated,
      authType: this.$store.getters.getAuthType,
      nav: currentNav,
      userId: (this.$store.getters.getAuthUserID || null),
      cartCount: (this.$store.getters.getCartCount || 0),
      contactName: (this.$store.getters.getAuthCustomerContactName || 'N/A'),
      contactId: (this.$store.getters.getAuthCustomerContactID || null),
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    isLoggedIn () {
      return this.loggedIn;
    },
    isTokenAuth() {
      return this.$store.getters.getAuthType === 'token';
    }
  },
  methods: {
    logout: function() {
      let vm = this;
      this.$store.dispatch(AUTH_LOGOUT, {vm}).then(() => {
        this.$router.push('/login');
      });
    }
  },
  created() {
    this.$store.watch((state, getters) => getters.isAuthenticated, (newIsAuthenticated) => {
      this.loggedIn = newIsAuthenticated;
      const currentAuthType = this.$store.getters.getAuthType;
      if (newIsAuthenticated) {
        if (currentAuthType === 'token') {
          this.nav = nav.items.filter(item => item.availableOnTokenAuth)
        } else {
          this.nav = nav.items;
        }
      } else {
        this.nav = nav_guest.items;
      }
    });
    this.$store.watch((state, getters) => getters.getAuthType, (newAuthType) => {
      if (this.loggedIn) {
        if (newAuthType === 'token') {
          this.nav = [
            {name: 'Results', icon: 'fal fa-vials', url: '/results'},
          ];
        } else {
          this.nav = nav.items;
        }
      }
    });
    this.$store.watch((state, getters) => getters.getAuthUserID, (value) => {
      this.userId = value;
    });
    this.$store.watch((state, getters) => getters.getCartCount, (value) => {
      this.cartCount = value;
    });
    this.$store.watch((state, getters) => getters.getAuthCustomerContactName, (value) => {
      this.contactName = value;
    });
    this.$store.watch((state, getters) => getters.getAuthCustomerContactID, (value) => {
      this.contactId = value;
    });
  },
  async mounted () {
    try {
      // const widget = await markerSDK.loadWidget({ project: process.env.VUE_APP_MARKER_PROJECT_ID }) // widget variable was unused
      await markerSDK.loadWidget({ project: process.env.VUE_APP_MARKER_PROJECT_ID })
    } catch (error) {
      console.error('Error loading Marker widget', error);
    }
  }
}
</script>
